import { Array as RunTypesArray, Literal, Optional, Record, String, Union } from "runtypes";
import { Reason } from "../../../types/error";
/**
 * DNS-TXT verification status
 */
export const ValidDnsTxtVerificationStatus = Record({
    status: Literal("VALID"),
    location: String,
    value: String,
});
export const ValidDnsTxtVerificationStatusArray = RunTypesArray(ValidDnsTxtVerificationStatus).withConstraint((elements) => elements.length > 0 || "Expect at least one valid element");
export const InvalidDnsTxtVerificationStatus = Record({
    status: Literal("INVALID"),
    location: Optional(String),
    value: Optional(String),
    reason: Reason,
});
export const DnsTxtVerificationStatus = Union(ValidDnsTxtVerificationStatus, InvalidDnsTxtVerificationStatus);
export const DnsTxtVerificationStatusArray = RunTypesArray(DnsTxtVerificationStatus);
/**
 * Data for v3 Fragments
 */
export const ValidDnsTxtVerificationStatusDataV3 = Record({
    identifier: String,
    value: String,
});
// by design runtypes will validate arrays when an object has only partial properties
// https://github.com/pelotom/runtypes/issues/32
export const InvalidDnsTxtVerificationStatusDataV3 = ValidDnsTxtVerificationStatusDataV3.asPartial().withConstraint((value) => !Array.isArray(value) || "can't be an array");
export const DnsTxtVerificationStatusDataV3 = Union(ValidDnsTxtVerificationStatusDataV3, InvalidDnsTxtVerificationStatusDataV3);
